module.exports = __webpack_public_path__ + "static/media/province.51700447.csv";